// TripReport.jsx - COMPLETE FIXED VERSION
// ✅ Date filtering fixed - extracts from timestamp/created_at fields
// ✅ Full-page scrolling enabled
// ✅ All syntax errors fixed
// ✅ Dynamic currency support
// ✅ Payment management with balance tracking
// ✅ Delivery Person Dropdown fixed (fetching from correct endpoint)

import React, { useState, useEffect, useContext } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { UserContext } from '../../Context/UserContext';
import { FaArrowLeft, FaCalendarAlt, FaChevronLeft, FaChevronRight, FaCheckCircle, FaExclamationTriangle, FaChartBar, FaChartLine } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import './TripReport.css';
import '../Form/CreateCustomerPage.css';


const CustomDatePicker = ({ value, onChange, placeholder }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [view, setView] = useState('days'); // 'days' | 'months' | 'years'
    const [currentDate, setCurrentDate] = useState(() => {
        if (value) {
            const parsed = new Date(value);
            if (!isNaN(parsed)) return parsed;
        }
        return new Date();
    });
    const [yearPage, setYearPage] = useState(() => Math.floor((currentDate.getFullYear()) / 12) * 12);

    const [popupDay, setPopupDay] = useState(() => value ? (new Date(value).getDate() || "") : "");
    const [popupMonth, setPopupMonth] = useState(() => value ? ((new Date(value).getMonth() + 1) || "") : "");
    const [popupYear, setPopupYear] = useState(() => value ? (new Date(value).getFullYear() || "") : "");

    useEffect(() => {
        if (value) {
            const parsed = new Date(value);
            if (!isNaN(parsed)) {
                setCurrentDate(parsed);
                setYearPage(Math.floor(parsed.getFullYear() / 12) * 12);
                setPopupDay(parsed.getDate() || "");
                setPopupMonth((parsed.getMonth() + 1) || "");
                setPopupYear(parsed.getFullYear() || "");
            }
        } else {
            setPopupDay(""); setPopupMonth(""); setPopupYear("");
        }
    }, [value]);

    const handleQuickChange = (type, val) => {
        if (type === 'day') setPopupDay(val);
        if (type === 'month') setPopupMonth(val);
        if (type === 'year') setPopupYear(val);
        const newDay = type === 'day' ? val : popupDay;
        const newMonth = type === 'month' ? val : popupMonth;
        const newYear = type === 'year' ? val : popupYear;
        if (newDay && newMonth && newYear) {
            const d = parseInt(newDay); const m = parseInt(newMonth) - 1; const y = parseInt(newYear);
            if (!isNaN(d) && !isNaN(m) && !isNaN(y) && y >= 1900 && y <= 2100) {
                const dateObj = new Date(y, m, d);
                if (!isNaN(dateObj)) {
                    setCurrentDate(dateObj);
                    setYearPage(Math.floor(y / 12) * 12);
                }
            }
        }
    };

    const applyQuickDate = () => {
        const d = parseInt(popupDay); const m = parseInt(popupMonth) - 1; const y = parseInt(popupYear);
        if (!isNaN(d) && !isNaN(m) && !isNaN(y) && y >= 1900 && y <= 2100) {
            const dateObj = new Date(y, m, d);
            if (!isNaN(dateObj)) {
                const formatted = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${String(dateObj.getDate()).padStart(2, "0")}`;
                onChange(formatted);
                setIsOpen(false);
            }
        }
    };

    const handleSelectDate = (day, e) => {
        e.stopPropagation();
        const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
        const formatted = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, "0")}-${String(newDate.getDate()).padStart(2, "0")}`;
        onChange(formatted);
        setIsOpen(false);
    };

    const handlePrevMonth = (e) => { e.stopPropagation(); setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)); };
    const handleNextMonth = (e) => { e.stopPropagation(); setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)); };

    const daysInMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
    const startOffset = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay() === 0 ? 6 : new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay() - 1;
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const selectedDateObj = value ? new Date(value) : null;
    const selectedYear = selectedDateObj ? selectedDateObj.getFullYear() : null;
    const selectedMonth = selectedDateObj ? selectedDateObj.getMonth() : null;
    const selectedDay = selectedDateObj ? selectedDateObj.getDate() : null;

    return (
        <div className="custom-datepicker-container" style={{ position: 'relative', width: '100%' }}>
            <div className="custom-datepicker-input" onClick={() => { setIsOpen(!isOpen); setView('days'); }} style={{ position: 'relative' }}>
                <input type="text" readOnly value={value || ""} placeholder={placeholder || "YYYY-MM-DD"} style={{ cursor: 'pointer', background: '#F3F6FB', width: '100%', height: '44px', padding: '0 16px', borderRadius: '8px', border: '1px solid transparent', fontWeight: '600', fontSize: '14px', color: '#1B1B29', boxSizing: 'border-box' }} />
                <FaCalendarAlt style={{ position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', color: '#604BE8', pointerEvents: 'none' }} />
            </div>
            {isOpen && (
                <>
                    <div className="custom-datepicker-backdrop" onClick={() => setIsOpen(false)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000 }} />
                    <div className="custom-datepicker-popup" style={{ position: 'absolute', top: 'calc(100% + 8px)', left: 0, width: '320px', background: '#ffffff', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.15)', padding: '24px', zIndex: 1001, border: '1px solid #e2e8f0', animation: 'slideDown 0.2s ease', boxSizing: 'border-box' }}>
                        <div className="custom-datepicker-quick-input" style={{ display: 'flex', gap: '8px', marginBottom: '20px', alignItems: 'center' }}>
                            <input type="text" placeholder="DD" maxLength={2} value={popupDay} onChange={(e) => handleQuickChange('day', e.target.value)} style={{ width: '50px', height: '36px', textAlign: 'center', background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '8px', fontSize: '14px', fontWeight: '600', color: '#1E293B' }} />
                            <span style={{ color: '#94A3B8', fontWeight: 'bold' }}>/</span>
                            <input type="text" placeholder="MM" maxLength={2} value={popupMonth} onChange={(e) => handleQuickChange('month', e.target.value)} style={{ width: '50px', height: '36px', textAlign: 'center', background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '8px', fontSize: '14px', fontWeight: '600', color: '#1E293B' }} />
                            <span style={{ color: '#94A3B8', fontWeight: 'bold' }}>/</span>
                            <input type="text" placeholder="YYYY" maxLength={4} value={popupYear} onChange={(e) => handleQuickChange('year', e.target.value)} style={{ width: '60px', height: '36px', textAlign: 'center', background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '8px', fontSize: '14px', fontWeight: '600', color: '#1E293B' }} />
                            <button type="button" onClick={applyQuickDate} style={{ flex: 1, height: '36px', background: '#604BE8', color: 'white', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>Apply</button>
                        </div>
                        {view === 'days' && (
                            <>
                                <div className="custom-datepicker-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '0 0 24px 0' }}>
                                    <button type="button" onClick={handlePrevMonth} className="cal-nav-btn" style={{ width: '36px', height: '36px', background: 'transparent', border: 'none', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#1B1B29', fontSize: '14px', transition: 'all 0.2s ease' }}><FaChevronLeft /></button>
                                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                        <span style={{ fontWeight: '700', fontSize: '16px', color: '#1B1B29', cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setView('months'); }}>{monthNames[month]}</span>
                                        <span style={{ fontWeight: '700', fontSize: '16px', color: '#1B1B29', cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setView('years'); }}>{year}</span>
                                    </div>
                                    <button type="button" onClick={handleNextMonth} className="cal-nav-btn" style={{ width: '36px', height: '36px', background: 'transparent', border: 'none', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#1B1B29', fontSize: '14px', transition: 'all 0.2s ease' }}><FaChevronRight /></button>
                                </div>
                                <div className="custom-datepicker-weekdays" style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', textAlign: 'center', marginBottom: '16px' }}>
                                    {["Mo", "Tu", "We", "Th", "Fri", "Sa", "Su"].map((w, i) => (<span key={i} style={{ fontSize: '13px', fontWeight: '700', color: '#1B1B29' }}>{w}</span>))}
                                </div>
                                <div className="custom-datepicker-days" style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '8px 4px' }}>
                                    {Array.from({ length: startOffset }).map((_, i) => (<div key={`empty-${i}`} />))}
                                    {Array.from({ length: daysInMonth }).map((_, i) => {
                                        const day = i + 1; const isSelected = selectedYear === year && selectedMonth === month && selectedDay === day;
                                        return (
                                            <button key={day} type="button" onClick={(e) => handleSelectDate(day, e)} className={`cal-day-btn ${isSelected ? 'selected' : ''}`} style={{ height: '36px', width: '100%', border: 'none', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: isSelected ? '700' : '600', cursor: 'pointer', background: isSelected ? '#604BE8' : 'transparent', color: isSelected ? '#ffffff' : '#1B1B29', transition: 'all 0.2s ease' }}>{day}</button>
                                        );
                                    })}
                                </div>
                            </>
                        )}
                        {view === 'months' && (
                            <div>
                                <div className="custom-datepicker-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '0 0 24px 0' }}>
                                    <button type="button" onClick={(e) => { e.stopPropagation(); setView('days'); }} style={{ width: '36px', height: '36px', background: '#F3F6FB', border: 'none', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#1B1B29', fontSize: '14px' }}><FaChevronLeft /></button>
                                    <span style={{ fontWeight: '700', fontSize: '16px', color: '#1B1B29' }}>Select Month</span>
                                    <div style={{ width: '36px' }} />
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}>
                                    {monthNames.map((mName, index) => (
                                        <button key={mName} type="button" onClick={(e) => { e.stopPropagation(); setCurrentDate(new Date(year, index, 1)); setView('days'); }} style={{ height: '42px', border: 'none', borderRadius: '10px', background: index === month ? '#604BE8' : '#F3F6FB', color: index === month ? '#ffffff' : '#1B1B29', fontWeight: '600', fontSize: '14px', cursor: 'pointer' }}>{mName.substring(0, 3)}</button>
                                    ))}
                                </div>
                            </div>
                        )}
                        {view === 'years' && (
                            <div>
                                <div className="custom-datepicker-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '0 0 24px 0' }}>
                                    <button type="button" onClick={(e) => { e.stopPropagation(); setYearPage(yearPage - 12); }} style={{ width: '36px', height: '36px', background: '#F3F6FB', border: 'none', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#1B1B29', fontSize: '14px' }}><FaChevronLeft /></button>
                                    <span style={{ fontWeight: '700', fontSize: '16px', color: '#1B1B29', cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); setView('days'); }}>{yearPage} - {yearPage + 11}</span>
                                    <button type="button" onClick={(e) => { e.stopPropagation(); setYearPage(yearPage + 12); }} style={{ width: '36px', height: '36px', background: 'transparent', border: 'none', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#1B1B29', fontSize: '14px' }}><FaChevronRight /></button>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}>
                                    {Array.from({ length: 12 }).map((_, i) => {
                                        const y = yearPage + i;
                                        return (
                                            <button key={y} type="button" onClick={(e) => { e.stopPropagation(); setCurrentDate(new Date(y, month, 1)); setView('days'); }} style={{ height: '42px', border: 'none', borderRadius: '10px', background: y === year ? '#604BE8' : '#F3F6FB', color: y === year ? '#ffffff' : '#1B1B29', fontWeight: '600', fontSize: '14px', cursor: 'pointer' }}>{y}</button>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

function TripReport() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [employees, setEmployees] = useState([]); // Will store only delivery boys
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [tripReports, setTripReports] = useState([]);
    const [filteredReports, setFilteredReports] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
    const [billNumber, setBillNumber] = useState('');
    const [customerName, setCustomerName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
    const [warningMessage, setWarningMessage] = useState('');
    const [warningType, setWarningType] = useState('warning');
    const [activePaymentMethods, setActivePaymentMethods] = useState({});
    const [vatRate, setVatRate] = useState(0.10);
    const [currency, setCurrency] = useState("INR");
    const [useCurrencySymbol, setUseCurrencySymbol] = useState(false);
    const API_URL = '';

    const getCurrencySymbol = (currCode) => {
        const symbols = {
            'INR': '₹',
            'USD': '$',
            'EUR': '€',
            'GBP': '£',
            'AED': 'د.إ',
            'JPY': '¥',
            'CNY': '¥',
            'SGD': '$',
            'MYR': 'RM',
            'THB': '฿',
            'IDR': 'Rp',
            'KRW': '₩',
            'PHP': '₱',
            'SAR': '﷼',
            'QAR': '﷼',
            'KWD': 'د.ك',
            'OMR': '﷼',
            'BHD': '.د.ب',
            'CAD': '$',
            'AUD': '$',
            'NZD': '$',
            'CHF': 'CHF',
            'ZAR': 'R',
            'BRL': 'R$',
            'PKR': '₨',
            'LKR': 'Rs',
            'NGN': '₦'
        };
        return symbols[currCode?.toUpperCase()] || '₹';
    };

    // Permissions
    const [canRead, setCanRead] = useState(false);
    const [canWrite, setCanWrite] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [canCreate, setCanCreate] = useState(false);

    // Context for global config
    const { baseUrl, configLoading } = useContext(UserContext);


    // Consolidated initial data fetching
    useEffect(() => {
        if (configLoading) return;

        const initializeData = async () => {
            try {
                const apiBase = baseUrl || "";
                // Parallelize meta-data
                const [permsRes, vatRes, settingsRes] = await Promise.all([
                    fetchPermissions(),
                    axios.get(`${apiBase}/api/get-vat`),
                    axios.get(`${apiBase}/api/settings`)
                ]);

                if (vatRes.data) {
                    setVatRate(vatRes.data.vat / 100 || 0.10);
                }
                if (settingsRes.data) {
                    setCurrency(settingsRes.data.currency?.toUpperCase() || "INR");
                    setUseCurrencySymbol(settingsRes.data.useCurrencySymbol || false);
                }

                // Initial business data
                await fetchEmployees();
            } catch (error) {
                console.error("Error in TripReport parallel fetch:", error);
            }
        };

        initializeData();
    }, [baseUrl, configLoading]);

    const fetchPermissions = async () => {
        try {
            const userStr = localStorage.getItem('user');
            if (!userStr) return;
            const userObj = JSON.parse(userStr);
            const role = userObj.role;
            if (!role) return;

            const url = `${baseUrl}/api/role-permissions?role=${role}`;
            const response = await axios.get(url);
            const perms = response.data.permissions || [];
            const pagePerm = perms.find(p => p.pageId === 'trip_report');
            if (pagePerm) {
                setCanRead(pagePerm.canRead === true);
                setCanWrite(pagePerm.canWrite === true);
                setCanDelete(pagePerm.canDelete === true);
                setCanCreate(pagePerm.canCreate === true);
            }
        } catch (error) {
            console.error("Error fetching permissions:", error);
        }
    };

    const generateShortUUID = () => {
        return uuidv4().slice(0, 8);
    };

    // UPDATED: Fetch only delivery employees
    const fetchEmployees = async () => {
        try {
            setLoading(true);
            setError(null);
            // Use specialized endpoint for delivery employees
            const response = await axios.get(`${baseUrl}/api/delivery-employees`);
            const data = Array.isArray(response.data) ? response.data : [];

            // Filter just to be safe, ensuring only delivery boys are included
            const deliveryBoys = data.filter(emp => emp.role && emp.role.toLowerCase() === 'delivery boy');

            setEmployees(deliveryBoys);
        } catch (err) {
            setError(`Failed to fetch employees: ${err.message}`);
            setEmployees([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchTripReports = async (employeeId, date, billNo, custName) => {
        if (!date) return;
        const fetchId = employeeId || 'all';
        try {
            setLoading(true);
            setError(null);
            const response = await axios.get(`${baseUrl}/api/tripreports/${fetchId}`);
            const data = Array.isArray(response.data) ? response.data : [];
            const sanitizedReports = data.map((report) => {
                let paymentAmounts = { Cash: 0, Card: 0, UPI: 0 };
                let tenderedAmount = report.tenderedAmount || '';
                let changeAmount = report.change || 0;
                let cardDetails = report.cardDetails || '';
                let upiDetails = report.upiDetails || '';
                let paymentMethods = [];
                if (Array.isArray(report.payments)) {
                    report.payments.forEach((p) => {
                        const method = p.mode_of_payment;
                        if (['Cash', 'Card', 'UPI'].includes(method)) {
                            paymentAmounts[method] = Number(p.amount) || 0;
                            if (method === 'Cash') {
                                tenderedAmount = p.tenderedAmount || '';
                                changeAmount = Number(p.change) || 0;
                            } else if (method === 'Card') {
                                cardDetails = p.cardNumber || p.cardDetails || '';
                            } else if (method === 'UPI') {
                                upiDetails = p.upiId || p.upiDetails || '';
                            }
                            if (Number(p.amount) > 0) paymentMethods.push(method);
                        }
                    });
                }
                const sanitizedCartItems = Array.isArray(report.cartItems)
                    ? report.cartItems.map((item) => {
                        let exclTotal = Number(item.excl_amount) || Number(item.exclTotal) || 0;
                        let taxTotal = Number(item.tax_amount) || Number(item.taxTotal) || 0;
                        const qty = Number(item.quantity) || 1;
                        const amount = Number(item.amount) || 0;
                        if ((exclTotal + taxTotal) === 0 && amount > 0) {
                            const unitIncl = amount / qty;
                            exclTotal = unitIncl / (1 + vatRate);
                            taxTotal = unitIncl - exclTotal;
                        }
                        return {
                            ...item,
                            id: item.id || uuidv4(),
                            item_name: item.item_name || item.name || 'Unknown',
                            name: item.name || item.item_name || 'Unknown',
                            quantity: qty,
                            basePrice: Number(item.basePrice) || (amount / qty) || 0,
                            totalPrice: amount || ((exclTotal + taxTotal) * qty) || 0,
                            exclTotal,
                            taxTotal,
                            taxBreakdown: item.tax_breakdown || item.taxBreakdown || {},
                            selectedSize: item.selectedSize || 'M',
                            icePreference: item.icePreference || 'without_ice',
                            icePrice: Number(item.icePrice) || 0,
                            isSpicy: item.isSpicy || false,
                            spicyPrice: Number(item.spicyPrice) || 0,
                            kitchen: item.kitchen || 'Main Kitchen',
                            addonQuantities: item.addonQuantities || {},
                            addonVariants: item.addonVariants || {},
                            addonPrices: item.addonPrices || {},
                            comboQuantities: item.comboQuantities || {},
                            comboVariants: item.comboVariants || {},
                            comboPrices: item.comboPrices || {},
                            addons: Array.isArray(item.addons) ? item.addons : [],
                            selectedCombos: Array.isArray(item.selectedCombos) ? item.selectedCombos : [],
                            ingredients: Array.isArray(item.ingredients) ? item.ingredients : [],
                            requiredKitchens: Array.isArray(item.requiredKitchens) ? item.requiredKitchens : [],
                            kitchenStatuses: item.kitchenStatuses || {},
                        };
                    })
                    : [];
                return {
                    ...report,
                    orderNo: report.orderNo || report.invoice_no || 'N/A',
                    tripId: report._id || uuidv4(),
                    status: report.status || 'Pending',
                    chairsBooked: Array.isArray(report.chairsBooked) ? report.chairsBooked : [],
                    cartItems: sanitizedCartItems,
                    pickedUpTime: report.pickedUpTime || null,
                    paymentMethods,
                    paymentAmounts,
                    tenderedAmount,
                    change: changeAmount,
                    cardDetails,
                    upiDetails,
                    email: report.email || 'N/A',
                    customerName: report.customer || 'N/A',
                    timestamp: report.timestamp || report.date,
                    deliveryPersonName: report.deliveryPersonName || selectedEmployee?.name || 'Unknown',
                };
            });
            console.log('Sanitized reports:', sanitizedReports);
            setTripReports(sanitizedReports);
            filterReportsByDate(sanitizedReports, date, billNo, custName);
        } catch (err) {
            setError(`Failed to fetch trip reports: ${err.message}`);
            setTripReports([]);
            setFilteredReports([]);
        } finally {
            setLoading(false);
        }
    };

    // ✅ FIXED: Date filtering now extracts from timestamp/created_at
    const filterReportsByDate = (reports, date, billNo, custName) => {
        console.log('Filtering reports by date:', date, 'billNo:', billNo, 'custName:', custName);
        if (!date) {
            setFilteredReports([]);
            return;
        }
        let filtered = reports.filter((report) => {
            let reportDate = '';
            if (report.timestamp) {
                reportDate = report.timestamp.split('T')[0];
            } else if (report.created_at) {
                reportDate = report.created_at.split('T')[0];
            }
            console.log('Report date extracted:', reportDate, 'comparing with:', date);
            return reportDate === date;
        });
        if (billNo) {
            filtered = filtered.filter((report) => report.orderNo.toLowerCase().includes(billNo.toLowerCase()));
        }
        if (custName) {
            filtered = filtered.filter((report) =>
                report.customerName && report.customerName.toLowerCase().includes(custName.toLowerCase())
            );
        }
        console.log('Filtered reports:', filtered);
        setFilteredReports(filtered);
    };

    const calculateSubtotal = (cartItems) => {
        if (!Array.isArray(cartItems)) return 0;
        return cartItems.reduce((sum, item) => sum + ((Number(item.exclTotal) || 0) * (Number(item.quantity) || 1)), 0);
    };

    const calculateTotalVat = (cartItems) => {
        if (!Array.isArray(cartItems)) return 0;
        return cartItems.reduce((sum, item) => sum + ((Number(item.taxTotal) || 0) * (Number(item.quantity) || 1)), 0);
    };

    const calculateGrandTotal = (cartItems) => {
        if (!Array.isArray(cartItems)) return 0;
        const subtotal = calculateSubtotal(cartItems);
        const vat = calculateTotalVat(cartItems);
        let total = (subtotal + vat).toFixed(2);
        if (parseFloat(total) === 0) {
            total = cartItems.reduce((sum, item) => sum + Number(item.amount || 0), 0).toFixed(2);
        }
        return total;
    };

    const calculateTotalPaid = (paymentAmounts) => {
        return Object.values(paymentAmounts).reduce((sum, amt) => sum + (Number(amt) || 0), 0);
    };

    const getBalance = (report) => {
        const grandTotal = parseFloat(calculateGrandTotal(report.cartItems));
        const totalPaid = calculateTotalPaid(report.paymentAmounts);
        return Math.max(0, grandTotal - totalPaid).toFixed(2);
    };

    const markAsDelivered = async (report) => {
        if (report.status === 'Delivered') {
            setWarningMessage('Payment is already received for this order.');
            setWarningType('warning');
            return;
        }
        const grandTotalNum = parseFloat(calculateGrandTotal(report.cartItems));
        const totalPaid = calculateTotalPaid(report.paymentAmounts);
        if (totalPaid < grandTotalNum - 0.01) {
            setWarningMessage(`Insufficient payment. Total Paid: ${getCurrencySymbol(currency)}${totalPaid.toFixed(2)}, Required: ${getCurrencySymbol(currency)}${grandTotalNum.toFixed(2)}`);
            setWarningType('warning');
            return;
        }
        try {
            const payments = [];
            ['Cash', 'Card', 'UPI'].forEach((method) => {
                const amount = Number(report.paymentAmounts[method]) || 0;
                if (amount > 0) {
                    let payObj = {
                        mode_of_payment: method,
                        amount: amount,
                    };
                    if (method === 'Cash') {
                        const tendered = parseFloat(report.tenderedAmount) || amount;
                        payObj.tenderedAmount = tendered;
                        payObj.change = Math.max(0, tendered - amount);
                    } else if (method === 'Card' && report.cardDetails) {
                        payObj.cardNumber = report.cardDetails;
                    } else if (method === 'UPI' && report.upiDetails) {
                        payObj.upiId = report.upiDetails;
                    }
                    payments.push(payObj);
                }
            });
            if (payments.length === 0) {
                setWarningMessage('No payment entered.');
                setWarningType('warning');
                return;
            }
            const payload = {
                orderNo: report.orderNo,
                status: 'Delivered',
                payments: payments,
                isManagerReconciled: true,
                pos_opening_entry_id: null
            };
            await axios.post(`${baseUrl}/api/sales/deliver-order`, payload);
            setWarningMessage('Order marked as Payment Received successfully with payment details.');
            setWarningType('success');
            if (selectedEmployee && selectedDate) {
                fetchTripReports(selectedEmployee.employeeId, selectedDate, billNumber, customerName);
            }
        } catch (err) {
            setWarningMessage(`Failed to mark as Payment Received: ${err.message}`);
            setWarningType('warning');
        }
    };

    const handlePaymentAmountChange = (reportId, method, value) => {
        const report = filteredReports.find((r) => r.tripId === reportId);
        if (report?.status === 'Delivered') {
            setWarningMessage('Cannot edit payments for an order where payment is already received.');
            setWarningType('warning');
            return;
        }
        const numValue = value === '' ? 0 : parseFloat(value);
        setFilteredReports((prevReports) =>
            prevReports.map((r) => {
                if (r.tripId === reportId) {
                    const newAmounts = { ...r.paymentAmounts, [method]: numValue };
                    let newTendered = r.tenderedAmount;
                    let newChange = r.change;
                    let newCardDetails = r.cardDetails;
                    let newUpiDetails = r.upiDetails;
                    if (numValue === 0) {
                        if (method === 'Cash') newTendered = '';
                        if (method === 'Card') newCardDetails = '';
                        if (method === 'UPI') newUpiDetails = '';
                    }
                    return {
                        ...r,
                        paymentAmounts: newAmounts,
                        ...(method === 'Cash' ? { tenderedAmount: newTendered, change: newChange } : {}),
                        ...(method === 'Card' ? { cardDetails: newCardDetails } : {}),
                        ...(method === 'UPI' ? { upiDetails: newUpiDetails } : {}),
                    };
                }
                return r;
            })
        );
    };

    const handleTenderedChange = (reportId, value) => {
        const report = filteredReports.find((r) => r.tripId === reportId);
        if (report?.status === 'Delivered') {
            setWarningMessage('Cannot edit details for an order where payment is already received.');
            setWarningType('warning');
            return;
        }
        const cashAmt = Number(report.paymentAmounts.Cash) || 0;
        const tendered = value === '' ? 0 : parseFloat(value);
        const ch = Math.max(0, tendered - cashAmt);
        setFilteredReports((prevReports) =>
            prevReports.map((r) =>
                r.tripId === reportId ? { ...r, tenderedAmount: value, change: ch } : r
            )
        );
    };

    const handlePaymentDetailsInput = (reportId, field, value) => {
        const report = filteredReports.find((r) => r.tripId === reportId);
        if (report?.status === 'Delivered') {
            setWarningMessage('Cannot edit details for an order where payment is already received.');
            setWarningType('warning');
            return;
        }
        setFilteredReports((prevReports) =>
            prevReports.map((report) => {
                if (report.tripId === reportId) {
                    return {
                        ...report,
                        [field]: value,
                    };
                }
                return report;
            })
        );
    };

    // Initialize state from URL params
    useEffect(() => {
        const empId = searchParams.get('employeeId');
        const date = searchParams.get('date');
        if (empId && date && employees.length > 0) {
            const emp = employees.find((e) => e.employeeId === empId);
            if (emp) {
                setSelectedEmployee(emp);
                setSelectedDate(date);
                fetchTripReports(empId, date, '', '');
                setWarningMessage(`Loaded trip report for ${emp.name} on ${date}`);
                setWarningType('success');
            }
        }
    }, [searchParams, employees]);

    // Replaced custo    // Fetch reports on initial mount when date is set
    useEffect(() => {
        if (selectedDate && employees.length > 0) {
            fetchTripReports(selectedEmployee?.employeeId || 'all', selectedDate, billNumber, customerName);
        }
    }, [employees.length]);

    const handleEmployeeSelectChange = (e) => {
        const empId = e.target.value;
        const emp = employees.find(e => e.employeeId === empId) || null;
        setSelectedEmployee(emp);
        setWarningMessage('');
        // Trigger fetch if date is already selected
        if (selectedDate) {
            fetchTripReports(empId || 'all', selectedDate, billNumber, customerName);
        }
    };

    const handleDateChange = (e) => {
        const date = e.target.value;
        setSelectedDate(date);
        setWarningMessage('');
        if (date) {
            fetchTripReports(selectedEmployee?.employeeId || 'all', date, billNumber, customerName);
        }
    };

    const handleBillNumberChange = (e) => {
        const billNo = e.target.value;
        setBillNumber(billNo);
        setWarningMessage('');
        if (selectedDate) {
            fetchTripReports(selectedEmployee?.employeeId || 'all', selectedDate, billNo, customerName);
        }
    };

    const handleCustomerNameChange = (e) => {
        const custName = e.target.value;
        setCustomerName(custName);
        setWarningMessage('');
        if (selectedDate) {
            fetchTripReports(selectedEmployee?.employeeId || 'all', selectedDate, billNumber, custName);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setWarningMessage('');
        if (!selectedDate) {
            setWarningMessage('Please select a date');
            setWarningType('warning');
            return;
        }
        fetchTripReports(selectedEmployee?.employeeId || 'all', selectedDate, billNumber, customerName);
        setWarningMessage(
            `Delivery Person Selected: ${selectedEmployee ? selectedEmployee.name : 'All'} for date ${selectedDate}${billNumber ? `, Bill No: ${billNumber}` : ''}${customerName ? `, Customer: ${customerName}` : ''}`
        );
        setWarningType('success');
    };

    const handleBack = () => {
        navigate('/home');
    };

    const handleShowDetails = (report) => {
        setSelectedReport(report);
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        setSelectedReport(null);
    };

    const handleWarningOk = () => {
        setWarningMessage('');
        setWarningType('warning');
    };

    const handleWarningCancel = () => {
        setWarningMessage('');
        setWarningType('warning');
    };

    const formatTimestamp = (timestamp) => {
        if (!timestamp) return 'N/A';
        return new Date(timestamp).toLocaleString();
    };

    const formatPrice = (price) => {
        const numPrice = Number(price);
        const displayPrice = isNaN(numPrice) || numPrice === 0 ? "0.00" : numPrice.toFixed(2);
        
        if (useCurrencySymbol && currency?.toUpperCase() === 'AED') {
            return (
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 344.84 299.91" style={{ height: '11px', width: 'auto', verticalAlign: 'middle', marginRight: '2px', display: 'inline-block', fill: '#000' }}>
                        <path d="M342.14,140.96l2.7,2.54v-7.72c0-17-11.92-30.84-26.56-30.84h-23.41C278.49,36.7,222.69,0,139.68,0c-52.86,0-59.65,0-109.71,0,0,0,15.03,12.63,15.03,52.4v52.58h-27.68c-5.38,0-10.43-2.08-14.61-6.01l-2.7-2.54v7.72c0,17.01,11.92,30.84,26.56,30.84h18.44s0,29.99,0,29.99h-27.68c-5.38,0-10.43-2.07-14.61-6.01l-2.7-2.54v7.71c0,17,11.92,30.82,26.56,30.82h18.44s0,54.89,0,54.89c0,38.65-15.03,50.06-15.03,50.06h109.71c85.62,0,139.64-36.96,155.38-104.98h32.46c5.38,0,10.43,2.07,14.61,6l2.7,2.54v-7.71c0-17-11.92-30.83-26.56-30.83h-18.9c.32-4.88.49-9.87.49-15s-.18-10.11-.51-14.99h28.17c5.37,0,10.43,2.07,14.61,6.01ZM89.96,15.01h45.86c61.7,0,97.44,27.33,108.1,89.94l-153.96.02V15.01ZM136.21,284.93h-46.26v-89.98l153.87-.02c-9.97,56.66-42.07,88.38-107.61,90ZM247.34,149.96c0,5.13-.11,10.13-.34,14.99l-157.04.02v-29.99l157.05-.02c.22,4.84.33,9.83.33,15Z"/>
                    </svg>
                    {displayPrice}
                </span>
            );
        }

        const symbol = useCurrencySymbol ? getCurrencySymbol(currency) : `${currency} `;
        return <>{symbol}{displayPrice}</>;
    };

    const calculatePendingGrandTotal = () => {
        return filteredReports
            .filter((report) => report.status !== 'Delivered')
            .reduce((sum, report) => {
                const gt = parseFloat(calculateGrandTotal(report.cartItems));
                const paid = calculateTotalPaid(report.paymentAmounts);
                return sum + Math.max(0, gt - paid);
            }, 0)
            .toFixed(2);
    };

    const calculateOverallGrandTotal = () => {
        return filteredReports.reduce((sum, report) => {
            return sum + parseFloat(calculateGrandTotal(report.cartItems));
        }, 0).toFixed(2);
    };

    const calculateTotalCollected = () => {
        return filteredReports.reduce((sum, report) => {
            return sum + calculateTotalPaid(report.paymentAmounts);
        }, 0).toFixed(2);
    };

    const renderAddonsInPopup = (item) => {
        const addons = item.addons || [];
        const addonQuantities = item.addonQuantities || {};
        const addonVariants = item.addonVariants || {};
        const addonPrices = item.addonPrices || {};

        if ((!addons || addons.length === 0) && Object.keys(addonQuantities).length === 0) return null;

        // If we have an array of addons (common for web/delivery apps)
        if (addons.length > 0) {
            return (
                <ul className="list-unstyled ms-3 mt-1">
                    {addons.map((addon, aIdx) => (
                        <li key={aIdx} className="text-muted small">
                            + {addon.addon_name || addon.name1 || addon.name || "Addon"} {addon.size ? `(${addon.size})` : ''} x{addon.addon_quantity} - {formatPrice((addon.addon_price * addon.addon_quantity) || 0)}
                        </li>
                    ))}
                </ul>
            );
        }

        // If we have structured quantities (common for POS/Internal orders)
        return (
            <ul className="list-unstyled ms-3 mt-1">
                {Object.entries(addonQuantities)
                    .filter(([_, qty]) => qty > 0)
                    .map(([name, qty], idx) => (
                        <li key={idx} className="text-muted small">
                            + {name} {addonVariants[name]?.size ? `(${addonVariants[name].size})` : ''} x{qty} - {formatPrice((addonPrices[name] || 0) * qty)}
                        </li>
                    ))}
            </ul>
        );
    };

    const renderCombosInPopup = (item) => {
        const selectedCombos = item.selectedCombos || [];
        const comboQuantities = item.comboQuantities || {};
        const comboVariants = item.comboVariants || {};
        const comboPrices = item.comboPrices || {};

        if ((!selectedCombos || selectedCombos.length === 0) && Object.keys(comboQuantities).length === 0) return null;

        if (selectedCombos.length > 0) {
            return (
                <ul className="list-unstyled ms-3 mt-1">
                    {selectedCombos.map((combo, cIdx) => (
                        <li key={cIdx} className="text-info small">
                            + {combo.combo_name || combo.name1 || combo.name || "Combo"} {combo.size ? `(${combo.size})` : ''} x{combo.combo_quantity} - {formatPrice((combo.combo_price * combo.combo_quantity) || 0)}
                        </li>
                    ))}
                </ul>
            );
        }

        return (
            <ul className="list-unstyled ms-3 mt-1">
                {Object.entries(comboQuantities)
                    .filter(([_, qty]) => qty > 0)
                    .map(([name, qty], idx) => (
                        <li key={idx} className="text-info small">
                            + {name} {comboVariants[name]?.size ? `(${comboVariants[name].size})` : ''} x{qty} - {formatPrice((comboPrices[name] || 0) * qty)}
                        </li>
                    ))}
            </ul>
        );
    };

    const renderIngredientsInPopup = (ingredients) => {
        if (!ingredients || ingredients.length === 0) return null;
        return (
            <ul className="list-unstyled ms-3 mt-1">
                {ingredients.map((ing, idx) => (
                    <li key={idx} className="text-muted small">
                        - {ing.name}: {ing.custom_weight || ing.weight || "N/A"}g ({formatPrice(ing.calculated_price || ing.base_price || 0)})
                    </li>
                ))}
            </ul>
        );
    };

    if (loading || configLoading) {
        return (
            <div className="trip-main-loading text-center text-muted fs-5 my-3">
                Loading Trip Report Data...
            </div>
        );
    }

    if (!canRead) {
        return (
            <div className="trip-main container text-center mt-5">
                <div className="alert alert-danger">
                    <h3>Access Denied</h3>
                    <p>You do not have permission to view Trip Reports.</p>
                </div>
                <button className="btn btn-primary" onClick={() => navigate("/home")}>
                    Back to Home
                </button>
            </div>
        );
    }

    const deliveryPersonSummaries = (() => {
        if (selectedEmployee) {
            return [{
                name: selectedEmployee.name,
                totalGrandTotal: filteredReports.length > 0 ? formatPrice(calculateOverallGrandTotal()) : '-',
                totalCollected: filteredReports.length > 0 ? formatPrice(calculateTotalCollected()) : '-',
                totalPending: filteredReports.length > 0 ? formatPrice(calculatePendingGrandTotal()) : '-'
            }];
        }

        const summaries = {};

        // Pre-populate with all employees from dropdown
        employees.forEach(emp => {
            if (emp.name) {
                summaries[emp.name] = {
                    name: emp.name,
                    totalGrandTotal: 0,
                    totalCollected: 0,
                    totalPending: 0
                };
            }
        });

        filteredReports.forEach(report => {
            const name = report.deliveryPersonName || 'Unknown';
            if (!summaries[name]) {
                summaries[name] = {
                    name: name,
                    totalGrandTotal: 0,
                    totalCollected: 0,
                    totalPending: 0
                };
            }
            const gt = parseFloat(calculateGrandTotal(report.cartItems));
            const paid = calculateTotalPaid(report.paymentAmounts);
            const pending = report.status !== 'Delivered' ? Math.max(0, gt - paid) : 0;

            summaries[name].totalGrandTotal += gt;
            summaries[name].totalCollected += paid;
            summaries[name].totalPending += pending;
        });

        return Object.values(summaries).map(s => ({
            name: s.name,
            totalGrandTotal: s.totalGrandTotal > 0 ? formatPrice(s.totalGrandTotal) : '-',
            totalCollected: s.totalCollected > 0 || s.totalGrandTotal > 0 ? formatPrice(s.totalCollected) : '-',
            totalPending: s.totalPending > 0 || s.totalGrandTotal > 0 ? formatPrice(s.totalPending) : '-'
        }));
    })();

    return (
        <div className="create-customer-container main-customer-page" style={{ background: '#ffffff', minHeight: '100vh' }}>
            <div className="customer-header-section" style={{ background: '#ffffff' }}>
                <div className="header-left">
                    <button onClick={handleBack} className="header-back-btn">
                        <FaArrowLeft /> Back
                    </button>
                </div>
                <div className="header-center">
                    <h1>Delivery Person Trip Report</h1>
                </div>
                <div className="header-right" style={{ display: 'flex', gap: '12px' }}>
                    <button onClick={() => navigate('/salespage')} style={{ background: '#f1f5f9', color: '#64748b', border: '1px solid #e2e8f0', padding: '10px 20px', borderRadius: '12px', fontWeight: '700', fontSize: '14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <FaChartBar /> Sales Page
                    </button>
                    <button onClick={() => navigate('/sales-reports')} style={{ background: '#604BE8', color: '#ffffff', border: 'none', padding: '10px 20px', borderRadius: '12px', fontWeight: '700', fontSize: '14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', boxShadow: '0 4px 12px rgba(96, 75, 232, 0.2)' }}>
                        <FaChartLine /> Sales Report
                    </button>
                </div>
            </div>
            <div className="header-divider"></div>

            <div className="customer-scroll-body" style={{ background: '#ffffff', padding: '20px' }}>
                {warningMessage && ReactDOM.createPortal(
                    <div className="premium-modal-overlay" style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(15, 23, 42, 0.6)',
                        backdropFilter: 'blur(8px)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 99999,
                        animation: 'fadeIn 0.2s ease-out'
                    }}>
                        <div className="premium-modal-box" style={{
                            background: '#ffffff',
                            borderRadius: '24px',
                            padding: '40px 32px',
                            width: '90%',
                            maxWidth: '440px',
                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.1)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            animation: 'modalScaleIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                            position: 'relative',
                            overflow: 'hidden'
                        }}>
                            <div style={{
                                position: 'absolute',
                                top: '-50px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '200px',
                                height: '200px',
                                background: warningType === 'success' ? 'radial-gradient(circle, rgba(6, 214, 160, 0.15) 0%, rgba(255,255,255,0) 70%)' : 'radial-gradient(circle, rgba(255, 159, 4, 0.15) 0%, rgba(255,255,255,0) 70%)',
                                zIndex: 0,
                                pointerEvents: 'none'
                            }}></div>

                            <div className="premium-modal-icon" style={{
                                width: '84px',
                                height: '84px',
                                borderRadius: '50%',
                                background: warningType === 'success' ? '#ecfdf5' : '#fffbeb',
                                color: warningType === 'success' ? '#06D6A0' : '#FF9F04',
                                border: `2px solid ${warningType === 'success' ? '#a7f3d0' : '#fde68a'}`,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '38px',
                                marginBottom: '24px',
                                boxShadow: warningType === 'success' ? '0 10px 25px -5px rgba(6, 214, 160, 0.2)' : '0 10px 25px -5px rgba(255, 159, 4, 0.2)',
                                zIndex: 1,
                                animation: 'bounceIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
                            }}>
                                {warningType === 'success' ? <FaCheckCircle /> : <FaExclamationTriangle />}
                            </div>

                            <h3 style={{
                                fontSize: '24px',
                                fontWeight: '800',
                                color: '#1e293b',
                                margin: '0 0 12px 0',
                                zIndex: 1,
                                fontFamily: `'Gilroy', 'Inter', sans-serif`
                            }}>
                                {warningType === 'success' ? "Success" : "Notice"}
                            </h3>

                            <p style={{
                                fontSize: '16px',
                                color: '#64748b',
                                lineHeight: '1.6',
                                margin: '0 0 32px 0',
                                zIndex: 1,
                                fontWeight: '500'
                            }}>
                                {warningMessage}
                            </p>

                            <div className="premium-modal-actions" style={{
                                display: 'flex',
                                gap: '16px',
                                width: '100%',
                                zIndex: 1
                            }}>
                                <button
                                    type="button"
                                    className="premium-btn-cancel"
                                    onClick={handleWarningCancel}
                                    style={{
                                        flex: 1,
                                        height: '48px',
                                        background: '#f1f5f9',
                                        color: '#64748b',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: '14px',
                                        fontWeight: '700',
                                        fontSize: '15px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        fontFamily: `'Gilroy', 'Inter', sans-serif`
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.color = '#334155'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.color = '#64748b'; }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="premium-btn-ok"
                                    onClick={handleWarningOk}
                                    style={{
                                        flex: 1,
                                        height: '48px',
                                        background: warningType === 'success' ? '#06D6A0' : '#604BE8',
                                        color: '#ffffff',
                                        border: 'none',
                                        borderRadius: '14px',
                                        fontWeight: '700',
                                        fontSize: '15px',
                                        cursor: 'pointer',
                                        boxShadow: warningType === 'success' ? '0 10px 20px -5px rgba(6, 214, 160, 0.3)' : '0 10px 20px -5px rgba(96, 75, 232, 0.3)',
                                        transition: 'all 0.2s ease',
                                        fontFamily: `'Gilroy', 'Inter', sans-serif`
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = warningType === 'success' ? '0 12px 25px -5px rgba(6, 214, 160, 0.4)' : '0 12px 25px -5px rgba(96, 75, 232, 0.4)'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = warningType === 'success' ? '0 10px 20px -5px rgba(6, 214, 160, 0.3)' : '0 10px 20px -5px rgba(96, 75, 232, 0.3)'; }}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>,
                    document.body
                )}
                {error && (
                    <div className="trip-main-error alert alert-danger my-3 text-center" style={{ borderRadius: '12px', fontWeight: '600' }}>
                        {error}
                    </div>
                )}

                <div style={{ marginBottom: '24px' }}>
                    <div className="section-header">
                        <h2>Filter Reports</h2>
                    </div>
                    <div className="form-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', padding: '0 20px 20px' }}>
                        <div className="form-group">
                            <label style={{ fontSize: '13px', fontWeight: '700', color: '#475569', marginBottom: '8px', display: 'block' }}>Select Delivery Person</label>
                            <select
                                className="form-control"
                                value={selectedEmployee ? selectedEmployee.employeeId : ''}
                                onChange={(e) => {
                                    const emp = employees.find((emp) => emp.employeeId === e.target.value);
                                    setSelectedEmployee(emp || null);
                                    // The original handleEmployeeSelectChange
                                    handleEmployeeSelectChange(e);
                                }}
                                style={{ background: '#F3F6FB', border: '1px solid transparent', height: '44px', borderRadius: '8px', padding: '0 16px', fontWeight: '600', fontSize: '14px', color: '#1B1B29', width: '100%' }}
                            >
                                <option value="">-- Select --</option>
                                {employees.map((emp) => (
                                    <option key={emp.employeeId} value={emp.employeeId}>
                                        {emp.name} (ID: {emp.employeeId})
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label style={{ fontSize: '13px', fontWeight: '700', color: '#475569', marginBottom: '8px', display: 'block' }}>Date Filter</label>
                            <CustomDatePicker
                                value={selectedDate}
                                onChange={(val) => {
                                    handleDateChange({ target: { value: val } });
                                }}
                                placeholder="Select Date"
                            />
                        </div>
                        <div className="form-group">
                            <label style={{ fontSize: '13px', fontWeight: '700', color: '#475569', marginBottom: '8px', display: 'block' }}>Bill Number</label>
                            <input
                                type="text"
                                className="form-control"
                                value={billNumber}
                                onChange={handleBillNumberChange}
                                placeholder="Search Bill No."
                                style={{ background: '#F3F6FB', border: '1px solid transparent', height: '44px', borderRadius: '8px', padding: '0 16px', fontWeight: '600', fontSize: '14px', color: '#1B1B29', width: '100%' }}
                            />
                        </div>
                        <div className="form-group">
                            <label style={{ fontSize: '13px', fontWeight: '700', color: '#475569', marginBottom: '8px', display: 'block' }}>Customer Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={customerName}
                                onChange={handleCustomerNameChange}
                                placeholder="Search Customer"
                                style={{ background: '#F3F6FB', border: '1px solid transparent', height: '44px', borderRadius: '8px', padding: '0 16px', fontWeight: '600', fontSize: '14px', color: '#1B1B29', width: '100%' }}
                            />
                        </div>
                    </div>
                </div>

                <div style={{ marginBottom: '24px' }}>
                    <div className="section-header">
                        <h2>Selected Delivery Person</h2>
                    </div>
                    <div className="active-orders-table-wrapper" style={{ padding: '0 20px 20px' }}>
                        <div className="active-orders-table-responsive">
                            <table className="active-orders-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Delivery Person Name in Reports</th>
                                        <th>Total Grand Total</th>
                                        <th>Total Collected</th>
                                        <th>Total Pending</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {deliveryPersonSummaries.length > 0 ? deliveryPersonSummaries.map((summary, idx) => (
                                        <tr key={idx}>
                                            <td>{summary.name}</td>
                                            <td>{summary.name}</td>
                                            <td>{summary.totalGrandTotal}</td>
                                            <td>{summary.totalCollected}</td>
                                            <td>{summary.totalPending}</td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td>{selectedEmployee ? selectedEmployee.name : 'All Delivery Persons'}</td>
                                            <td>{selectedEmployee ? selectedEmployee.name : 'All'}</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {filteredReports.length > 0 && (
                    <div>
                        <div className="section-header">
                            <h2>Assigned Delivery Orders</h2>
                        </div>
                        <div className="active-orders-table-wrapper" style={{ padding: '0 20px 20px' }}>
                            <div className="active-orders-table-responsive">
                                <table className="active-orders-table active-orders-table-striped">
                                    <thead>
                                        <tr>
                                            <th>Order No</th>
                                            <th>Date</th>
                                            <th>Customer</th>
                                            <th>Email</th>
                                            <th>Grand Total ({useCurrencySymbol && currency?.toUpperCase() === 'AED' ? (
                                                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 344.84 299.91" style={{ height: '11px', width: 'auto', verticalAlign: 'middle', display: 'inline-block', fill: '#000' }}>
                                                        <path d="M342.14,140.96l2.7,2.54v-7.72c0-17-11.92-30.84-26.56-30.84h-23.41C278.49,36.7,222.69,0,139.68,0c-52.86,0-59.65,0-109.71,0,0,0,15.03,12.63,15.03,52.4v52.58h-27.68c-5.38,0-10.43-2.08-14.61-6.01l-2.7-2.54v7.72c0,17.01,11.92,30.84,26.56,30.84h18.44s0,29.99,0,29.99h-27.68c-5.38,0-10.43-2.07-14.61-6.01l-2.7-2.54v7.71c0,17,11.92,30.82,26.56,30.82h18.44s0,54.89,0,54.89c0,38.65-15.03,50.06-15.03,50.06h109.71c85.62,0,139.64-36.96,155.38-104.98h32.46c5.38,0,10.43,2.07,14.61,6l2.7,2.54v-7.71c0-17-11.92-30.83-26.56-30.83h-18.9c.32-4.88.49-9.87.49-15s-.18-10.11-.51-14.99h28.17c5.37,0,10.43,2.07,14.61,6.01ZM89.96,15.01h45.86c61.7,0,97.44,27.33,108.1,89.94l-153.96.02V15.01ZM136.21,284.93h-46.26v-89.98l153.87-.02c-9.97,56.66-42.07,88.38-107.61,90ZM247.34,149.96c0,5.13-.11,10.13-.34,14.99l-157.04.02v-29.99l157.05-.02c.22,4.84.33,9.83.33,15Z"/>
                                                    </svg>
                                                </span>
                                            ) : (useCurrencySymbol ? getCurrencySymbol(currency) : currency)})</th>
                                            <th>Balance ({useCurrencySymbol && currency?.toUpperCase() === 'AED' ? (
                                                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 344.84 299.91" style={{ height: '11px', width: 'auto', verticalAlign: 'middle', display: 'inline-block', fill: '#000' }}>
                                                        <path d="M342.14,140.96l2.7,2.54v-7.72c0-17-11.92-30.84-26.56-30.84h-23.41C278.49,36.7,222.69,0,139.68,0c-52.86,0-59.65,0-109.71,0,0,0,15.03,12.63,15.03,52.4v52.58h-27.68c-5.38,0-10.43-2.08-14.61-6.01l-2.7-2.54v7.72c0,17.01,11.92,30.84,26.56,30.84h18.44s0,29.99,0,29.99h-27.68c-5.38,0-10.43-2.07-14.61-6.01l-2.7-2.54v7.71c0,17,11.92,30.82,26.56,30.82h18.44s0,54.89,0,54.89c0,38.65-15.03,50.06-15.03,50.06h109.71c85.62,0,139.64-36.96,155.38-104.98h32.46c5.38,0,10.43,2.07,14.61,6l2.7,2.54v-7.71c0-17-11.92-30.83-26.56-30.83h-18.9c.32-4.88.49-9.87.49-15s-.18-10.11-.51-14.99h28.17c5.37,0,10.43,2.07,14.61,6.01ZM89.96,15.01h45.86c61.7,0,97.44,27.33,108.1,89.94l-153.96.02V15.01ZM136.21,284.93h-46.26v-89.98l153.87-.02c-9.97,56.66-42.07,88.38-107.61,90ZM247.34,149.96c0,5.13-.11,10.13-.34,14.99l-157.04.02v-29.99l157.05-.02c.22,4.84.33,9.83.33,15Z"/>
                                                    </svg>
                                                </span>
                                            ) : (useCurrencySymbol ? getCurrencySymbol(currency) : currency)})</th>
                                            <th>Payment Method</th>
                                            <th>Actions</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredReports.map((report) => (
                                            <tr key={report.tripId}>
                                                <td>{report.orderNo}</td>
                                                <td>{formatTimestamp(report.timestamp)}</td>
                                                <td>{report.customerName || 'N/A'}</td>
                                                <td>{report.email || 'N/A'}</td>
                                                <td>{formatPrice(calculateGrandTotal(report.cartItems))}</td>
                                                <td style={{ color: getBalance(report) > 0 ? '#F59E0B' : '#10B981', fontWeight: '600' }}>{formatPrice(getBalance(report))}</td>
                                                <td>
                                                    {report.status === 'Delivered' ? (
                                                        <div className="d-flex flex-column gap-1" style={{ fontSize: '13px', color: '#475569' }}>
                                                            {Object.entries(report.paymentAmounts)
                                                                .filter(([, amt]) => Number(amt) > 0)
                                                                .map(([method, amt]) => (
                                                                    <div key={method}>
                                                                        <strong style={{ color: '#0F172A' }}>{method}:</strong> {formatPrice(amt.toFixed(2))}

                                                                        {method === 'Card' && report.cardDetails && (
                                                                            <span style={{ color: '#64748B' }}> (****{report.cardDetails.slice(-4)})</span>
                                                                        )}
                                                                        {method === 'UPI' && report.upiDetails && (
                                                                            <span style={{ color: '#64748B' }}> ({report.upiDetails.split('@')[0]})</span>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            <div className="mt-1 pt-1" style={{ borderTop: '1px solid #E2E8F0' }}>
                                                                <strong style={{ color: '#0F172A' }}>Total Paid: {formatPrice(calculateTotalPaid(report.paymentAmounts).toFixed(2))}</strong>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="d-flex flex-wrap align-items-center gap-2">
                                                            <select 
                                                                className="form-select form-select-sm" 
                                                                style={{ width: '130px', fontSize: '13px', background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '6px' }}
                                                                value={activePaymentMethods[report.tripId] || ''}
                                                                onChange={(e) => setActivePaymentMethods(prev => ({...prev, [report.tripId]: e.target.value}))}
                                                            >
                                                                <option value="">- Select Method -</option>
                                                                <option value="Cash">Cash</option>
                                                                <option value="Card">Card</option>
                                                                <option value="UPI">UPI</option>
                                                            </select>

                                                            {activePaymentMethods[report.tripId] === 'Cash' && (
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <label style={{ fontSize: '13px', fontWeight: '600', color: '#475569', margin: 0, width: '40px' }}>Cash:</label>
                                                                    <input
                                                                        type="number"
                                                                        value={report.paymentAmounts.Cash || ''}
                                                                        onChange={(e) => handlePaymentAmountChange(report.tripId, 'Cash', e.target.value)}
                                                                        min="0" step="0.01"
                                                                        style={{ background: '#F8FAFC', border: '1px solid #E2E8F0', height: '32px', borderRadius: '6px', padding: '0 8px', width: '80px', fontSize: '13px' }}
                                                                    />
                                                                </div>
                                                            )}
                                                            {activePaymentMethods[report.tripId] === 'Card' && (
                                                                <>
                                                                    <div className="d-flex align-items-center gap-2 mt-1">
                                                                        <label style={{ fontSize: '13px', fontWeight: '600', color: '#475569', margin: 0, width: '40px' }}>Card:</label>
                                                                        <input
                                                                            type="number"
                                                                            value={report.paymentAmounts.Card || ''}
                                                                            onChange={(e) => handlePaymentAmountChange(report.tripId, 'Card', e.target.value)}
                                                                            min="0" step="0.01"
                                                                            style={{ background: '#F8FAFC', border: '1px solid #E2E8F0', height: '32px', borderRadius: '6px', padding: '0 8px', width: '80px', fontSize: '13px' }}
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <input
                                                                            type="text"
                                                                            placeholder="Card Number"
                                                                            value={report.cardDetails || ''}
                                                                            onChange={(e) => handlePaymentDetailsInput(report.tripId, 'cardDetails', e.target.value)}
                                                                            style={{ background: '#F8FAFC', border: '1px solid #E2E8F0', height: '32px', borderRadius: '6px', padding: '0 8px', width: '130px', fontSize: '13px' }}
                                                                        />
                                                                    </div>
                                                                </>
                                                            )}
                                                            {activePaymentMethods[report.tripId] === 'UPI' && (
                                                                <>
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <label style={{ fontSize: '13px', fontWeight: '600', color: '#475569', margin: 0, width: '40px' }}>UPI:</label>
                                                                        <input
                                                                            type="number"
                                                                            value={report.paymentAmounts.UPI || ''}
                                                                            onChange={(e) => handlePaymentAmountChange(report.tripId, 'UPI', e.target.value)}
                                                                            min="0" step="0.01"
                                                                            style={{ background: '#F8FAFC', border: '1px solid #E2E8F0', height: '32px', borderRadius: '6px', padding: '0 8px', width: '80px', fontSize: '13px' }}
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <input
                                                                            type="text"
                                                                            placeholder="UPI ID"
                                                                            value={report.upiDetails || ''}
                                                                            onChange={(e) => handlePaymentDetailsInput(report.tripId, 'upiDetails', e.target.value)}
                                                                            style={{ background: '#F8FAFC', border: '1px solid #E2E8F0', height: '32px', borderRadius: '6px', padding: '0 8px', width: '130px', fontSize: '13px' }}
                                                                        />
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    <button
                                                        style={{ background: '#eff2f9', color: '#604BE8', border: '1.5px solid #C3CDE4', borderRadius: '8px', padding: '6px 12px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', transition: 'all 0.2s ease' }}
                                                        onClick={() => handleShowDetails(report)}
                                                    >
                                                        Details
                                                    </button>
                                                </td>
                                                <td>
                                                    {report.status === 'Delivered' ? (
                                                        <span style={{ display: 'inline-block', background: '#D1FAE5', color: '#065F46', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '700' }}>Payment Received</span>
                                                    ) : (
                                                        <button
                                                            style={{ 
                                                                background: Object.values(report.paymentAmounts || {}).some(amt => Number(amt) > 0) ? '#10B981' : '#9CA3AF', 
                                                                color: 'white', 
                                                                border: 'none', 
                                                                borderRadius: '8px', 
                                                                padding: '8px 16px', 
                                                                fontSize: '13px', 
                                                                fontWeight: '700', 
                                                                cursor: Object.values(report.paymentAmounts || {}).some(amt => Number(amt) > 0) ? 'pointer' : 'not-allowed', 
                                                                boxShadow: Object.values(report.paymentAmounts || {}).some(amt => Number(amt) > 0) ? '0 2px 4px rgba(16, 185, 129, 0.2)' : 'none' 
                                                            }}
                                                            disabled={!Object.values(report.paymentAmounts || {}).some(amt => Number(amt) > 0)}
                                                            title={!Object.values(report.paymentAmounts || {}).some(amt => Number(amt) > 0) ? "Please enter at least one payment amount (Cash/Card/UPI) before marking as received" : ""}
                                                            onClick={() => markAsDelivered(report)}
                                                        >
                                                            Payment Received
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="mt-4 text-end">
                                <h5 style={{ color: '#0F172A', fontWeight: '700' }}>
                                    Total Pending Orders: <span style={{ color: '#F59E0B' }}>{formatPrice(calculatePendingGrandTotal())}</span>
                                </h5>
                            </div>
                        </div>
                    </div>
                )}

                {filteredReports.length === 0 && !loading && (
                    <div style={{ textAlign: 'center', padding: '40px', background: '#F8FAFC', borderRadius: '16px', border: '1px dashed #CBD5E1', marginTop: '24px' }}>
                        <p style={{ margin: 0, fontSize: '15px', color: '#64748B', fontWeight: '500' }}>
                            No delivery orders assigned to {selectedEmployee ? selectedEmployee.name : 'any delivery person'} for the selected date
                            {billNumber ? ` and bill number ${billNumber}` : ''}
                            {customerName ? ` and customer ${customerName}` : ''}.
                        </p>
                    </div>
                )}

            </div>

            {/* Popups updated to premium modal style */}
            {showPopup && selectedReport && (
                <div className="premium-modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}>
                    <div className="premium-modal-content" style={{ background: '#ffffff', width: '90%', maxWidth: '700px', borderRadius: '24px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', overflow: 'hidden', animation: 'modalSlideUp 0.3s ease-out' }}>
                        <div className="modal-header" style={{ padding: '24px 32px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc' }}>
                            <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '800', color: '#0f172a' }}>Order Details</h3>
                            <button onClick={handleClosePopup} style={{ background: 'none', border: 'none', fontSize: '24px', color: '#94a3b8', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>&times;</button>
                        </div>
                        <div className="modal-body" style={{ padding: '32px', maxHeight: '70vh', overflowY: 'auto' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
                                <div><span style={{ color: '#64748b', fontSize: '13px', fontWeight: '600' }}>Order No</span><div style={{ fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>{selectedReport.orderNo}</div></div>
                                <div><span style={{ color: '#64748b', fontSize: '13px', fontWeight: '600' }}>Date</span><div style={{ fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>{formatTimestamp(selectedReport.timestamp)}</div></div>
                                <div><span style={{ color: '#64748b', fontSize: '13px', fontWeight: '600' }}>Customer</span><div style={{ fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>{selectedReport.customerName || 'N/A'}</div></div>
                                <div><span style={{ color: '#64748b', fontSize: '13px', fontWeight: '600' }}>Email</span><div style={{ fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>{selectedReport.email || 'N/A'}</div></div>
                            </div>

                            <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '12px', marginBottom: '24px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}><span style={{ color: '#475569', fontWeight: '600' }}>Grand Total</span><strong style={{ color: '#0f172a' }}>{formatPrice(calculateGrandTotal(selectedReport.cartItems))}</strong></div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}><span style={{ color: '#475569', fontWeight: '600' }}>Subtotal</span><strong style={{ color: '#0f172a' }}>{formatPrice(calculateSubtotal(selectedReport.cartItems))}</strong></div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}><span style={{ color: '#475569', fontWeight: '600' }}>VAT ({(vatRate * 100).toFixed(0)}%)</span><strong style={{ color: '#0f172a' }}>{formatPrice(calculateTotalVat(selectedReport.cartItems))}</strong></div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', borderTop: '1px solid #e2e8f0', paddingTop: '8px' }}><span style={{ color: '#475569', fontWeight: '600' }}>Total Paid</span><strong style={{ color: '#0f172a' }}>{formatPrice(calculateTotalPaid(selectedReport.paymentAmounts).toFixed(2))}</strong></div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ color: '#475569', fontWeight: '600' }}>Balance</span><strong style={{ color: getBalance(selectedReport) > 0 ? '#F59E0B' : '#10B981' }}>{formatPrice(getBalance(selectedReport))}</strong></div>
                            </div>

                            {Object.entries(selectedReport.paymentAmounts).some(([, amt]) => Number(amt) > 0) && (
                                <div style={{ marginBottom: '24px' }}>
                                    <h4 style={{ fontSize: '15px', fontWeight: '700', color: '#0f172a', marginBottom: '12px' }}>Payments</h4>
                                    <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px' }}>
                                        {Object.entries(selectedReport.paymentAmounts).filter(([, amt]) => Number(amt) > 0).map(([method, amt]) => (
                                            <div key={method} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '14px' }}>
                                                <span style={{ fontWeight: '600', color: '#475569' }}>{method}</span>
                                                <span style={{ fontWeight: '700', color: '#0f172a' }}>
                                                    {formatPrice(amt.toFixed(2))}
                                                    {method === 'Card' && selectedReport.cardDetails && <span style={{ color: '#64748b', fontWeight: 'normal', fontSize: '13px' }}> (****{selectedReport.cardDetails.slice(-4)})</span>}
                                                    {method === 'UPI' && selectedReport.upiDetails && <span style={{ color: '#64748b', fontWeight: 'normal', fontSize: '13px' }}> ({selectedReport.upiDetails})</span>}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div>
                                <h4 style={{ fontSize: '15px', fontWeight: '700', color: '#0f172a', marginBottom: '12px' }}>Items</h4>
                                <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px' }}>
                                    {selectedReport.cartItems.map((item, idx) => (
                                        <div key={idx} style={{ marginBottom: idx < selectedReport.cartItems.length - 1 ? '16px' : '0', paddingBottom: idx < selectedReport.cartItems.length - 1 ? '16px' : '0', borderBottom: idx < selectedReport.cartItems.length - 1 ? '1px solid #f1f5f9' : 'none' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                                <strong style={{ fontSize: '15px', color: '#0f172a' }}>{item.name} <span style={{ color: '#64748b', fontWeight: 'normal' }}>x{item.quantity}</span></strong>
                                                <strong style={{ fontSize: '15px', color: '#0f172a' }}>{formatPrice((item.exclTotal + item.taxTotal) * item.quantity)}</strong>
                                            </div>
                                            <div style={{ fontSize: '13px', color: '#64748b' }}>Subtotal: {formatPrice(item.exclTotal * item.quantity)}, VAT: {formatPrice(item.taxTotal * item.quantity)}</div>
                                            <div style={{ fontSize: '13px' }}>
                                                {renderAddonsInPopup(item)}
                                                {renderCombosInPopup(item)}
                                                {renderIngredientsInPopup(item.ingredients)}
                                                {item.icePreference === 'with_ice' && item.icePrice > 0 && <div style={{ color: '#64748b', marginTop: '4px' }}>+ Ice x{item.quantity} - {formatPrice((item.icePrice * item.quantity))}</div>}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer" style={{ padding: '20px 32px', borderTop: '1px solid #f1f5f9', background: '#f8fafc', display: 'flex', justifyContent: 'flex-end' }}>
                            <button onClick={handleClosePopup} style={{ background: '#eff2f9', color: '#1e293b', border: 'none', padding: '12px 24px', borderRadius: '12px', fontWeight: '700', fontSize: '14px', cursor: 'pointer' }}>Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

}

export default TripReport;
